import { render, staticRenderFns } from "./begin_import.vue?vue&type=template&id=3f002658&scoped=true&"
import script from "./begin_import.vue?vue&type=script&lang=tsx&"
export * from "./begin_import.vue?vue&type=script&lang=tsx&"
import style0 from "./begin_import.vue?vue&type=style&index=0&id=3f002658&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f002658",
  null
  
)

export default component.exports